import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { RightPanelNotifier } from '../notifiers/right-panel-notifier';
import { RightPanelState } from '../states/right-panel-state';

@Injectable({ providedIn: 'root' })
export class RightPanelProvider extends BaseProvider<RightPanelNotifier, RightPanelState> {
  constructor() {
    super(RightPanelNotifier);
  }
}
